import { createAction, createSlice } from "@reduxjs/toolkit";

import listFactory from "../../../store/listFactory";

import type { UUID } from "../../../utils";
import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { CashManagementAccount } from "../models/CashManagement";

const { slicePart, selectors } = listFactory<CashManagementAccount>(
  "cashManagement"
);

const initialState = {
  ...slicePart.initialState,
  testSettlementResponse: {},
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setList: slicePart.reducers.setList,
    setItem: slicePart.reducers.setItem,
    updateItem: slicePart.reducers.updateItem,
    setSettlementTestResponse: (state, action) => {
      const { data } = action.payload;

      state.testSettlementResponse = data;
    },
  },
});

export const { setList, setItem, updateItem } = slice.actions;

export const fetchAccounts = createAction<{
  id: UUID;
  active?: boolean | undefined;
}>("fetchCashManagementAccounts");

export const fetchAccount = createAction<ObjectWithId>(
  "fetchCashManagementAccount"
);

export const updateAccount = createAction<{
  id: UUID;
  data: CashManagementAccount;
}>("updateCashManagementAccount");

export const createAccount = createAction<{
  id: UUID;
  data: CashManagementAccount;
}>("createCashManagementAccount");

export const sendTestSettlementBatch = createAction<
  ObjectWithId,
  "sendTestSettlementBatch"
>("sendTestSettlementBatch");

export const setAccountActiveFlag = createAction<{
  id: UUID;
  data: { active: boolean };
}>("setCashManagementAccountActiveFlag");

export const {
  selectList: selectAccounts,
  selectItem: selectAccount,
} = selectors;

export const selectTestSettlementResponse = (state: any) => {
  return state.cashManagement.testSettlementResponse;
};

export const cashManagementOperationPaths = (id?: UUID) => {
  return {
    listing: ["cashManagement", "listing", id],
    details: ["cashManagement", "details", id],
    update: ["cashManagement", "update", id],
    create: ["cashManagement", "create", id],
    setActiveFlag: ["cashManagement", "setActiveFlag", id],
    sendTestSettlementBatch: ["cashManagement", "sendSettlementBatch", id],
  };
};

export default slice.reducer;
